/* NOMI v23.28 — recipes gallery + bottom-sheet recipe with serving scaler. Data: assets/nomi-recipes.json. */
(function () {
  'use strict';
  var root = document.querySelector('[data-nrp]');
  if (!root) return;
  var $ = function (s, el) { return (el || root).querySelector(s); };
  var $$ = function (s, el) { return Array.prototype.slice.call((el || root).querySelectorAll(s)); };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };

  var IMG = root.getAttribute('data-img-base') || '';
  /* v23.68: ask the CDN for a sized copy (cookbook-x.webp -> cookbook-x_800x.webp) */
  var sz = function (name, w) { return String(name).replace(/\.webp$/, '_' + w + 'x.webp'); };
  var TAG = root.getAttribute('data-amazon-tag') || '';
  var PAGE = 24;
  var CUPS = {};
  try { CUPS = JSON.parse($('[data-nrp-cups]').textContent) || {}; } catch (e) {}
  var CAT = { healthy: 'Feel-good', classics: 'Classics', fun: 'Turn it up', comfort: 'Comfort' };
  var CATNOTE = { healthy: 'Bowls you can eat every day', classics: 'Butter, cheese and the dishes you grew up on', fun: 'Noodles as a building material', comfort: 'Gas-station food, done on purpose' };
  var CUPN = { beef: 'Umami Beef', chicken: 'Golden Chicken', curry: 'Tokyo Curry', garlic: 'Black Garlic' };
  var HEAT = { none: 'No heat', mild: 'Mild', medium: 'Medium', hot: 'Hot' };
  var FMT = { broth: 'Brothy', dry: 'Saucy', salad: 'Salad', handheld: 'Handheld', baked: 'Baked' };
  var DIET = { vegetarian: 'Vegetarian', vegan: 'Vegan', dairy_free: 'Dairy-free', pescatarian: 'Pescatarian' };

  var R = [], byId = {}, list = [], shown = 0, cur = null, serves = 1;
  var state = { q: '', cat: 'all', cup: '', time: '', diet: '', protein: '', heat: '', fmt: '', sort: 'featured' };

  /* ---------- URL state ---------- */
  function readUrl() {
    var p = new URLSearchParams(location.search);
    Object.keys(state).forEach(function (k) { if (p.has(k)) state[k] = p.get(k); });
    if (!CAT[state.cat]) state.cat = 'all';
  }
  function writeUrl() {
    var p = new URLSearchParams();
    Object.keys(state).forEach(function (k) { var v = state[k]; if (v && !(k === 'cat' && v === 'all') && !(k === 'sort' && v === 'featured')) p.set(k, v); });
    var qs = p.toString();
    var hash = cur ? '#recipe-' + cur.id : '';
    history.replaceState(null, '', location.pathname + (qs ? '?' + qs : '') + hash);
  }

  /* ---------- filtering ---------- */
  function hay(r) { return (r._h = r._h || (r.title + ' ' + r.hook + ' ' + (r.cuisine || '') + ' ' + r.ingredients.map(function (i) { return i.item; }).join(' ') + ' ' + CUPN[r.cup] + ' ' + CAT[r.cat] + ' ' + (r.story || []).join(' ')).toLowerCase()); }
  function apply() {
    var q = state.q.trim().toLowerCase().split(/\s+/).filter(Boolean);
    list = R.filter(function (r) {
      if (state.cat !== 'all' && r.cat !== state.cat) return false;
      if (state.cup && r.cup !== state.cup) return false;
      if (state.diet && r.diet.indexOf(state.diet) < 0) return false;
      if (state.heat && r.heat !== state.heat) return false;
      if (state.fmt && r.fmt !== state.fmt) return false;
      if (state.time) { var t = +state.time; if (t === 21 ? r.minutes <= 20 : r.minutes > t) return false; }
      if (state.protein && r.macros.p < +state.protein) return false;
      if (q.length) { var h = hay(r); for (var i = 0; i < q.length; i++) if (h.indexOf(q[i]) < 0) return false; }
      return true;
    });
    var s = state.sort;
    if (s === 'protein') list.sort(function (a, b) { return b.macros.p - a.macros.p; });
    else if (s === 'kcal') list.sort(function (a, b) { return a.macros.kcal - b.macros.kcal; });
    else if (s === 'quick') list.sort(function (a, b) { return a.minutes - b.minutes; });
    else if (s === 'az') list.sort(function (a, b) { return a.title.localeCompare(b.title); });
    else if (s === 'new') list.sort(function (a, b) { return (b.trend === 'new') - (a.trend === 'new') || a.n - b.n; });
    else list.sort(function (a, b) { return a.n - b.n; });
    shown = 0;
    $('[data-nrp-grid]').innerHTML = '';
    more();
    var n = list.length;
    $('[data-nrp-count]').textContent = n === R.length ? R.length + ' recipes' : n + ' of ' + R.length + ' recipes';
    var dirty = state.q || state.cat !== 'all' || state.cup || state.time || state.diet || state.protein || state.heat || state.fmt;
    $('[data-nrp-clear]').classList.toggle('is-on', !!dirty);
    $$('[data-nrp-chip]').forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-nrp-chip') === state.cat ? 'true' : 'false'); });
    $$('select[data-nrp-sel]').forEach(function (s) { s.value = state[s.getAttribute('data-nrp-sel')] || (s.name === 'sort' ? 'featured' : ''); s.classList.toggle('is-set', !!s.value && s.value !== 'featured'); });
    $('[data-nrp-search-wrap]').classList.toggle('has-value', !!state.q);
    writeUrl();
  }
  function card(r, mini) {
    var badge = r.trend === 'new' ? '<span class="nrp-badge nrp-badge--new">New</span>' : (r.trend === 'original' ? '<span class="nrp-badge">Original</span>' : '');
    return '<button type="button" class="nrp-card" data-nrp-open="' + esc(r.id) + '" aria-label="' + esc(r.title) + '">' + (mini ? '' : badge) +
      '<img src="' + IMG + esc(sz(r.image, 800)) + '" srcset="' + IMG + esc(sz(r.image, 480)) + ' 480w, ' + IMG + esc(sz(r.image, 800)) + ' 800w" sizes="(max-width: 700px) 50vw, 25vw" alt="' + esc(r.title) + '" loading="lazy" decoding="async" width="1200" height="1600">' +
      '<span class="nrp-card-body"><span class="nrp-cap"><span>' + esc(CAT[r.cat]) + '</span><i></i><span class="c2">' + esc(CUPN[r.cup]) + '</span></span><h3>' + esc(r.title) + '</h3>' +
      '<span class="nrp-card-facts"><span><b>' + r.macros.kcal + '</b><em> kcal</em></span><span><b>' + r.macros.p + 'g</b><em> protein</em></span><span><b>' + r.minutes + '</b><em> min</em></span></span></span></button>';
  }
  function more() {
    var g = $('[data-nrp-grid]');
    if (!list.length) { g.innerHTML = '<div class="nrp-empty"><b>Nothing matches that.</b>Try fewer filters, or search for an ingredient you have.</div>'; $('[data-nrp-more]').hidden = true; return; }
    var html = '';
    var end = Math.min(list.length, shown + PAGE);
    for (var i = shown; i < end; i++) html += card(list[i]);
    g.insertAdjacentHTML('beforeend', html);
    shown = end;
    var btn = $('[data-nrp-more]');
    btn.hidden = shown >= list.length;
    btn.textContent = 'Show ' + Math.min(PAGE, list.length - shown) + ' more of ' + list.length;
  }

  /* ---------- quantity scaling ---------- */
  var VF = { '¼': .25, '½': .5, '¾': .75, '⅓': 1 / 3, '⅔': 2 / 3, '⅛': .125, '⅜': .375, '⅝': .625, '⅞': .875 };
  var NUM = '(\\d+\\s+\\d+\\/\\d+|\\d+\\/\\d+|\\d+(?:\\.\\d+)?\\s*[¼½¾⅓⅔⅛⅜⅝⅞]|[¼½¾⅓⅔⅛⅜⅝⅞]|\\d+(?:\\.\\d+)?)';
  var LEAD = new RegExp('^' + NUM + '(?:\\s*[–-]\\s*' + NUM + ')?');
  function toNum(s) {
    s = s.trim();
    var m;
    if ((m = s.match(/^(\d+)\s+(\d+)\/(\d+)$/))) return +m[1] + m[2] / m[3];
    if ((m = s.match(/^(\d+)\/(\d+)$/))) return m[1] / m[2];
    if ((m = s.match(/^(\d+(?:\.\d+)?)\s*([¼½¾⅓⅔⅛⅜⅝⅞])$/))) return +m[1] + VF[m[2]];
    if (VF[s] != null) return VF[s];
    return parseFloat(s);
  }
  function fmtNum(v) {
    if (v >= 10) return String(Math.round(v));
    var whole = Math.floor(v), frac = v - whole;
    var F = [[0, ''], [.125, '⅛'], [.25, '¼'], [1 / 3, '⅓'], [.375, '⅜'], [.5, '½'], [.625, '⅝'], [2 / 3, '⅔'], [.75, '¾'], [.875, '⅞'], [1, '']];
    var best = F[0];
    for (var i = 0; i < F.length; i++) if (Math.abs(F[i][0] - frac) < Math.abs(best[0] - frac)) best = F[i];
    if (best[0] === 1) { whole += 1; best = F[0]; }
    if (!whole && !best[1]) return v < .07 ? 'pinch' : '⅛';
    return (whole || '') + best[1];
  }
  function scaleQty(q, n) {
    if (!q || n === 1) return q;
    var out = q.replace(LEAD, function (m, a, b) { return fmtNum(toNum(a) * n) + (b ? '–' + fmtNum(toNum(b) * n) : ''); });
    out = out.replace(/^(\S+)\s+(large |small |medium |big )?(cup|clove|slice|piece|wedge|sheet|strip|sprig|stalk|stick|can|packet|handful|pinch|scoop|tortilla|bun|egg|leaf|link|patty|fillet|rasher|square|knob|ball|head|bunch|jar|tin|bag|dash|splash|drizzle)\b(?!s)/, function (m, num, adj, u) {
      var v = toNum(num); if (!(v > 1)) return m;
      return num + ' ' + (adj || '') + (u === 'leaf' ? 'leaves' : u === 'patty' ? 'patties' : u + 's');
    });
    out = out.replace(/\((\d+(?:\.\d+)?)\s*g\)/g, function (m, g) { return '(' + Math.round(g * n) + ' g)'; });
    out = out.replace(/\((\d+(?:\.\d+)?)\s*g total\)/g, function (m, g) { return '(' + Math.round(g * n) + ' g total)'; });
    return out;
  }

  /* ---------- sheet ---------- */
  var dlg = $('[data-nrp-sheet]');
  function amazon(qq) { return 'https://www.amazon.com/s?k=' + encodeURIComponent(qq) + (TAG ? '&tag=' + encodeURIComponent(TAG) : ''); }
  function n1(v) { return v >= 100 ? Math.round(v) : Math.round(v * 10) / 10; }
  function renderSheet(r) {
    cur = r;
    var cup = CUPS[r.cup] || {};
    var m = r.macros;
    var idx = list.indexOf(r);
    $('[data-nrp-prev]').disabled = idx <= 0;
    $('[data-nrp-next]').disabled = idx < 0 || idx >= list.length - 1;
    $('[data-nrp-sheet-img]').src = IMG + sz(r.image, 1200);
    $('[data-nrp-sheet-img]').alt = r.title;
    var meta = [CAT[r.cat], CUPN[r.cup] + ' cup', r.minutes + ' min', HEAT[r.heat] || ''].filter(Boolean);
    if (r.cuisine) meta.push(r.cuisine);
    $('[data-nrp-sheet-kicker]').innerHTML = meta.map(esc).join('<i></i>');
    $('[data-nrp-sheet-title]').textContent = r.title;
    $('[data-nrp-sheet-hook]').textContent = r.hook;
    var tiles = [['kcal', m.kcal, '', 'Calories', 0], ['p', m.p, 'g', 'Protein', 1], ['c', m.c, 'g', 'Carbs', 0], ['fat', m.fat, 'g', 'Fat', 0], ['f', m.f, 'g', 'Fiber', 0], ['na', m.na, 'mg', 'Sodium', 0]];
    $('[data-nrp-macros]').innerHTML = tiles.map(function (t) { return '<div class="nrp-macro' + (t[4] ? ' nrp-macro--hi' : '') + '"><b>' + n1(t[1]) + '<small>' + t[2] + '</small></b><span>' + t[3] + '</span></div>'; }).join('');
    var cta = $('[data-nrp-cta]');
    var soldout = cup.state === 'soldout' || cup.state === 'sold-out';
    cta.href = cup.url || '/collections/all';
    cta.innerHTML = (soldout ? 'Pre-order ' : 'Shop ') + esc(CUPN[r.cup]) + (cup.price && cup.price.indexOf('—') < 0 && !soldout ? '<span class="nrp-cta-price">' + esc(cup.price) + '</span>' : '');
    $('[data-nrp-tags]').innerHTML = [FMT[r.fmt]].concat(r.diet.map(function (d) { return DIET[d] || d; })).concat(r.occasion || []).filter(Boolean).map(function (t) { return '<span>' + esc(t) + '</span>'; }).join('');
    $('[data-nrp-steps]').innerHTML = r.steps.map(function (s) { return '<li>' + esc(s) + '</li>'; }).join('');
    $('[data-nrp-story]').innerHTML = (r.story || []).map(function (p) { return '<p>' + esc(p) + '</p>'; }).join('') + (r.inspiration ? '<p class="nrp-insp">Inspired by: ' + esc(r.inspiration) + '</p>' : '');
    // related: same cup or category, not this
    var rel = R.filter(function (x) { return x.id !== r.id && (x.cat === r.cat); }).sort(function (a, b) { return (b.cup === r.cup) - (a.cup === r.cup) || Math.abs(a.n - r.n) - Math.abs(b.n - r.n); }).slice(0, 4);
    $('[data-nrp-related]').innerHTML = rel.map(function (x) { return card(x, true); }).join('');
    setServes(serves, true);
    $('[data-nrp-sheet-in]').scrollTop = 0;
  }
  function setServes(n, silent) {
    serves = n;
    $$('[data-nrp-serve]').forEach(function (b) { b.setAttribute('aria-pressed', +b.getAttribute('data-nrp-serve') === n ? 'true' : 'false'); });
    var r = cur; if (!r) return;
    var cup = CUPS[r.cup] || {};
    $('[data-nrp-ing]').innerHTML = r.ingredients.map(function (i) {
      var q = i.cup ? (n + (n > 1 ? ' cups' : ' cup')) : scaleQty(i.qty, n);
      var link = i.cup ? '<a href="' + esc(cup.url || '/collections/all') + '">Shop</a>' : (i.a ? '<a href="' + amazon(i.a) + '" target="_blank" rel="noopener sponsored">Amazon</a>' : '');
      var item = i.cup ? 'NOMI ' + CUPN[r.cup] : i.item;
      return '<li><span class="q' + (n > 1 && q ? ' is-scaled' : '') + '">' + esc(q) + '</span><span class="i' + (i.cup ? ' is-cup' : '') + '">' + esc(item) + '</span><span class="l">' + link + '</span></li>';
    }).join('');
    var m = r.macros;
    $('[data-nrp-batch]').innerHTML = n === 1
      ? 'Per serving, built on <b>one cup</b>. Macros are calculated from USDA values for the listed amounts plus the cup.'
      : 'Whole batch for <b>' + n + '</b>: <b>' + Math.round(m.kcal * n).toLocaleString() + ' kcal</b> · ' + Math.round(m.p * n) + ' g protein · ' + Math.round(m.c * n) + ' g carbs · ' + Math.round(m.fat * n) + ' g fat · ' + Math.round(m.na * n).toLocaleString() + ' mg sodium. You need <b>' + n + ' cups</b>. Per-serving macros stay the same.';
    $('[data-nrp-serve-note]').innerHTML = n === 1 ? 'One cup, one bowl. Pick a number to scale everything for the table.' : 'Everything below is scaled ×' + n + '. Cook the cups in one pot if you have it; keep the timings.';
    $('[data-nrp-ing-count]').textContent = r.ingredients.length + ' items · for ' + n;
    if (!silent) writeUrl();
  }
  function open(id, push) {
    var r = byId[id]; if (!r) return;
    if (list.indexOf(r) < 0 && !state.q && state.cat === 'all') { /* fine */ }
    renderSheet(r);
    if (!dlg.open) { try { dlg.showModal(); } catch (e) { dlg.setAttribute('open', ''); } document.body.classList.add('nrp-lock'); }
    writeUrl();
    var c = $('[data-nrp-close]'); if (c) c.focus();
  }
  function close() {
    if (dlg.open) dlg.close(); else dlg.removeAttribute('open');
    document.body.classList.remove('nrp-lock');
    var id = cur && cur.id; cur = null;
    writeUrl();
    var el = id && $('[data-nrp-open="' + id + '"]'); if (el) el.focus({ preventScroll: true });
  }
  function step(d) { var i = list.indexOf(cur); var r = list[i + d]; if (r) { renderSheet(r); writeUrl(); } }

  /* ---------- events ---------- */
  root.addEventListener('click', function (e) {
    var t = e.target.closest('[data-nrp-open],[data-nrp-chip],[data-nrp-more],[data-nrp-clear],[data-nrp-serve],[data-nrp-close],[data-nrp-prev],[data-nrp-next],[data-nrp-print],[data-nrp-search-x],[data-nrp-jump]');
    if (!t) { if (e.target === dlg) close(); return; }
    if (t.hasAttribute('data-nrp-open')) open(t.getAttribute('data-nrp-open'));
    else if (t.hasAttribute('data-nrp-chip')) { state.cat = t.getAttribute('data-nrp-chip'); apply(); }
    else if (t.hasAttribute('data-nrp-more')) more();
    else if (t.hasAttribute('data-nrp-clear')) { Object.keys(state).forEach(function (k) { state[k] = k === 'cat' ? 'all' : (k === 'sort' ? 'featured' : ''); }); $('[data-nrp-search]').value = ''; apply(); }
    else if (t.hasAttribute('data-nrp-serve')) setServes(+t.getAttribute('data-nrp-serve'));
    else if (t.hasAttribute('data-nrp-close')) close();
    else if (t.hasAttribute('data-nrp-prev')) step(-1);
    else if (t.hasAttribute('data-nrp-next')) step(1);
    else if (t.hasAttribute('data-nrp-print')) window.print();
    else if (t.hasAttribute('data-nrp-search-x')) { state.q = ''; $('[data-nrp-search]').value = ''; apply(); }
    else if (t.hasAttribute('data-nrp-jump')) { e.preventDefault(); var g = $('[data-nrp-bar]'); if (g) window.scrollTo({ top: g.getBoundingClientRect().top + window.scrollY - 60, behavior: 'smooth' }); }
  });
  dlg.addEventListener('cancel', function (e) { e.preventDefault(); close(); });
  dlg.addEventListener('keydown', function (e) { if (e.key === 'ArrowRight') step(1); else if (e.key === 'ArrowLeft') step(-1); });
  var deb;
  $('[data-nrp-search]').addEventListener('input', function (e) { clearTimeout(deb); var v = e.target.value; deb = setTimeout(function () { state.q = v; apply(); }, 160); });
  $$('select[data-nrp-sel]').forEach(function (s) { s.addEventListener('change', function () { state[s.getAttribute('data-nrp-sel')] = s.value; apply(); }); });
  // links elsewhere on the page (video captions, hero) open a recipe by hash
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href^="#recipe-"]'); if (!a) return;
    var id = a.getAttribute('href').slice(8); if (byId[id]) { e.preventDefault(); open(id); }
  });
  window.addEventListener('hashchange', function () { var m = location.hash.match(/^#recipe-(.+)$/); if (m && byId[m[1]] && (!cur || cur.id !== m[1])) open(m[1]); });

  /* ---------- boot ---------- */
  readUrl();
  $('[data-nrp-search]').value = state.q;
  fetch(root.getAttribute('data-src'), { credentials: 'omit' }).then(function (r) { return r.json(); }).then(function (data) {
    R = data; R.forEach(function (r) { byId[r.id] = r; });
    apply();
    var m = location.hash.match(/^#recipe-(.+)$/);
    if (m && byId[m[1]]) open(m[1]);
    var stat = $('[data-nrp-total]'); if (stat) stat.textContent = R.length;
  }).catch(function () { $('[data-nrp-grid]').innerHTML = '<div class="nrp-empty"><b>The cookbook didn’t load.</b>Refresh the page, or grab the PDF below.</div>'; });
})();
